import { render, staticRenderFns } from "./UniversityCourseAutoComplete.vue?vue&type=template&id=1f87d0ee&"
import script from "./UniversityCourseAutoComplete.vue?vue&type=script&lang=js&"
export * from "./UniversityCourseAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports